import { render } from "./SettingsPage.vue?vue&type=template&id=8ddcec82&ts=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&lang=ts"

import "./SettingsPage.vue?vue&type=style&index=0&id=8ddcec82&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__